import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectMedicalExpenseIPMIStep = (state) => state.get('medicalExpenseIPMIStep');

const makeSelectMedicalExpenseIPMIStep = () => createSelector(
  selectMedicalExpenseIPMIStep,
  (stepMedicalExpenseIPMIState) => ({
    doYouHaveAnyOtherTypeOfCoverage: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'doYouHaveAnyOtherTypeOfCoverage']),
      ''
    ),
    insuranceCarriersName: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'insuranceCarriersName']),
      ''
    ),
    natureOfInjury: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'natureOfInjury']),
      ''
    ),
    address: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'address']),
      ''
    ),
    cityOrTown: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'cityOrTown']),
      ''
    ),
    country: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'country']),
      ''
    ),
    postalCode: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'postalCode']),
      ''
    ),
    policyId: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'policyId']),
      ''
    ),
    nameOfTourOperatorOrCruiseOrLineOrAirline: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'nameOfTourOperatorOrCruiseOrLineOrAirline']),
      ''
    ),
    typeOfPolicy: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'typeOfPolicy']),
      ''
    ),
    contact: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'contact']),
      ''
    ),
    phoneNumber: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'phoneNumber']),
      ''
    ),
    isTheClaimTheResultOfASicknessOrInjury: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'isTheClaimTheResultOfASicknessOrInjury']),
      ''
    ),
    natureOfSickness: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'natureOfSickness']),
      ''
    ),
    accidentOfInjury: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'accidentOfInjury']),
      ''
    ),
    dateNature: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'dateNature']),
      ''
    ),
    placeNature: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'placeNature']),
      ''
    ),
    wasThereAnyPreviousTreatmentForThisCondition: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'wasThereAnyPreviousTreatmentForThisCondition']),
      ''
    ),
    dateSicknessOrInjuryBegan: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'dateSicknessOrInjuryBegan']),
      ''
    ),
    dateFirstTreated: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'dateFirstTreated']),
      ''
    ),
    nameOfPhysician: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'nameOfPhysician']),
      ''
    ),
    addressPhysician: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'addressPhysician']),
      ''
    ),
    cityOrTownPhysician: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'cityOrTownPhysician']),
      ''
    ),
    countryPhysician: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'countryPhysician']),
      ''
    ),
    zipPhysician: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'zipPhysician']),
      ''
    ),
    phonePhysician: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'phonePhysician']),
      ''
    ),
    datesOfTreatment: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'datesOfTreatment']),
      ''
    ),
    expenseDescriptionOfItems: mapWithDefault(stepMedicalExpenseIPMIState, () => stepMedicalExpenseIPMIState.getIn(['form', 'expenseDescriptionOfItems']) && stepMedicalExpenseIPMIState.getIn(['form', 'expenseDescriptionOfItems']).toJS(), ''),
    treatmentDates: mapWithDefault(stepMedicalExpenseIPMIState, () => stepMedicalExpenseIPMIState.getIn(['form', 'treatmentDates']) && stepMedicalExpenseIPMIState.getIn(['form', 'treatmentDates']).toJS(), []),

    isTheClaimTheResultOfADentalEmergency: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'isTheClaimTheResultOfADentalEmergency']),
      ''
    ),

    dateOfReturnToYourHomeCountry: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'dateOfReturnToYourHomeCountry']),
      ''
    ),

    dateOfDepartureFromYourHomeCountry: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'dateOfDepartureFromYourHomeCountry']),
      ''
    ),

    areYouEntitledToAnySocialMedicalCare: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'areYouEntitledToAnySocialMedicalCare']),
      ''
    ),

    didYouHaveOtherMedicalInsurancePolicy: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'didYouHaveOtherMedicalInsurancePolicy']),
      ''
    ),
    treatmentType: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'treatmentType']),
      ''
    ),
    amountClaimed: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'amountClaimed']),
      ''
    ),
    currency: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'currency']),
      ''
    ),
    dateSymptomsStarted: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'dateSymptomsStarted']),
      ''
    ),
    dateFirstTreatedSickness: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'dateFirstTreatedSickness']),
      ''
    ),
    diagnosisDetails: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'diagnosisDetails']),
      ''
    ),
    pleaseDescribeWhatHappened: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'pleaseDescribeWhatHappened']),
      ''
    ),
    wasTheAccidentCausedByAThirdParty: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'wasTheAccidentCausedByAThirdParty']),
      ''
    ),
    pleaseDescribeWhatHappenedDentalEmergency: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'pleaseDescribeWhatHappenedDentalEmergency']),
      ''
    ),
    diagnosisDetailsDentalEmergency: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'diagnosisDetailsDentalEmergency']),
      ''
    ),
    pleaseProviderFullDetails: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'pleaseProviderFullDetails']),
      ''
    ),
    insuranceCarriersNameMedical: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'insuranceCarriersNameMedical']),
      ''
    ),
    addressMedical: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'addressMedical']),
      ''
    ),
    cityOrTownMedical: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'cityOrTownMedical']),
      ''
    ),
    countryMedical: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'countryMedical']),
      ''
    ),
    postalCodeMedical: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'postalCodeMedical']),
      ''
    ),
    policyIdMedical: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'policyIdMedical']),
      ''
    ),
    nameOfTheFacility: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'nameOfTheFacility']),
      ''
    ),
    nameOfPhysicianDentist: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'nameOfPhysicianDentist']),
      ''
    ),
    addressTreatmentExpense: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'addressTreatmentExpense']),
      ''
    ),
    cityTreatmentExpense: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'cityTreatmentExpense']),
      ''
    ),
    countryTreatmentExpense: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'countryTreatmentExpense']),
      ''
    ),
    postalCodeTreatmentExpense: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'postalCodeTreatmentExpense']),
      ''
    ),
    phoneNumberTreatmentExpense: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'phoneNumberTreatmentExpense']),
      ''
    ),
    emailTreatmentExpense: mapWithDefault(
      stepMedicalExpenseIPMIState,
      () => stepMedicalExpenseIPMIState.getIn(['form', 'emailTreatmentExpense']),
      ''
    ),
  })
);

const makeSelectMedicalExpenseIPMIStepErrors = () =>
  createSelector(selectMedicalExpenseIPMIStep, (state) => state.get('errors'));

export {
  makeSelectMedicalExpenseIPMIStep,
  makeSelectMedicalExpenseIPMIStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.IPMI.MedicalExpense/selectors.js